import type { NicePayBillingCallback200Data } from './nicePayBillingCallback200Data';

export type NicePayBillingCallback200 = {
  /** 응답 데이터 */
  data?: NicePayBillingCallback200Data;
  /** 응답 메시지 */
  message: string;
  /** 성공 여부 */
  success: boolean;
};
